import Cookies, { CookieSetOptions } from 'universal-cookie';

const cookies = new Cookies();

export const setCookie = (name: string, value: string, option?: CookieSetOptions) => {
	return new Cookies().set(name, value, { ...option });
};

export const getCookie = (name: string) => {
	return new Cookies().get(name);
};

export const removeCookie = (name: string, option?: CookieSetOptions) => {
	return cookies.remove(name, { ...option });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getContextCookie = (context: any) => {
	if (!context || !context.req.headers.cookie) return '';
	const cookie = context.req.headers.cookie.split(';');

	const _token = cookie.find((item: string) => item.includes('imms_access_token'));

	const token = _token ? _token.split('=')[1] : '';

	return token;
};
